<template>
  <div class="modern-select">
    <v-select
      v-model="selectedValue"
      :items="options"
      :label="label"
      :placeholder="placeholder"
      :loading="loading"
      :disabled="disabled"
      :clearable="clearable"
      :multiple="multiple"
      :chips="chips"
      :item-title="itemTitle"
      :item-value="itemValue"
      @update:model-value="handleChange"
      @change="handleChange"
    >
      <template v-slot:selection="{ item }">
        <span v-if="multiple">
          {{ (item.raw && item.raw[itemTitle]) || (item[itemTitle]) || item }}
        </span>
        <span v-else>
          {{ (item.raw && item.raw[itemTitle]) || (item[itemTitle]) || item }}
        </span>
      </template>
      
      <template v-slot:item="{ item, props }">
        <v-list-item v-bind="props">
          <v-list-item-title>{{ (item.raw && item.raw[itemTitle]) || (item[itemTitle]) || item }}</v-list-item-title>
          <v-list-item-subtitle v-if="(item.raw && item.raw[itemSubtitle]) || (item[itemSubtitle])">
            {{ (item.raw && item.raw[itemSubtitle]) || (item[itemSubtitle]) }}
          </v-list-item-subtitle>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'ModernSelect',
  props: {
    modelValue: {
      type: [String, Number, Array, Object],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Seleccionar...'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    itemTitle: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemSubtitle: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    selectedValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>
.modern-select {
  width: 100%;
}
</style> 